import { Box, styled, Theme } from '@mui/material';
import { palette } from 'view/themes/palette';

export const Wrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
    height: 'auto',
    width: '100%',
    gap: '24px',
    backgroundColor: palette.background.general,

    [theme.breakpoints.down('tablet')]: {
      padding: 0,
      backgroundColor: palette.white,
      gap: '32px',
    },
  };
});

export const MainContentWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '80%',
    position: 'relative',
    paddingBottom: '24px',
    display: 'flex',
    gap: '24px',

    [theme.breakpoints.down('desktop')]: {
      width: '95%',
    },

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: '0 16px 32px 16px',
      gap: '32px',
    },
  };
});

export const RightBlockWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: 'calc(100% - 270px - 24px)', // gap = 24px, menuWidth = 270px
    minHeight: '720px',
    /* height: 'auto', */
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',

    [theme.breakpoints.down('tablet')]: {
      minHeight: 'calc(100vh - 136px)',
      width: '100%',
      gap: '32px',
    },
  };
});

export const RightBlockMain = styled(Box)<{ isReady: boolean }>(({
  theme,
  isReady,
}: {
  theme: Theme;
  isReady: boolean;
}) => {
  return {
    width: '100%',
    height: '100%',
    padding: isReady ? '24px' : 0,
    borderRadius: '24px',
    backgroundColor: palette.white,
    position: 'relative',

    [theme.breakpoints.down('tablet')]: {
      padding: '0',
    },
  };
});
